let impressionFired = false;
// Variable which stores the DataLayer (or DL) event name for AffiliateUnit load tracking purposes
export const affiliateUnitDLEventName = 'affiliate service';
/**
 * @return `true` if impression has been fired
 */
export function trackAffiliateUnitImpression() {
    if (!impressionFired) {
        impressionFired = true;
        return true;
    }
    return false;
}
